import React from "react";

export const Bio = () => {
  return (
    <section className="main section-center initial-section">
      {/* className='bio-card card-section */}
      <div className="bio-card">
        <div className="center-text">
          <p>
            Dr. Olga Berkovich is a certified piano teacher (MTCT & RCM),
            pianist, composer, musicologist, and educator.{" "}
          </p>
          <p>
            Dr. Berkovich holds BM and MM degrees in Piano Performance and
            Composition, a Doctor of Musical Arts (DMA) in Composition from the
            Moscow State Tchaikovsky Conservatory, and a PhD in Music Pedagogy
            from the Russian Academy of Education. Her doctoral research focused
            on innovative methods of teaching composition to future music
            educators.
          </p>
          <p>
            An award-winning composer, Dr. Berkovich received the Gold Medal at
            the First All-Russian Composer Competition while still a student.
            Her works have been performed internationally, including by the
            Russian State Symphony Orchestra, and she has collaborated as a
            composer and arranger with the Astra Philharmonic Orchestra and the
            BBC Orchestra in South Korea. She is also the author of numerous
            publications on music education, including the book Methods of
            Teaching Composition and Improvisation, published in both Russia and
            Germany.{" "}
          </p>
          <p>
            With nearly 30 years of teaching experience, Dr. Berkovich has
            taught at music schools, colleges, and universities, served as a
            competition adjudicator, and presented masterclasses. She currently
            serves on the Piano Faculty at Groton Hill Music Center in
            Massachusetts and maintains a successful private piano studio. Her
            students consistently earn top honors in festivals, examinations,
            and competitions, with performances at prestigious venues including
            Carnegie Hall and Harvard University.
          </p>
          <p>
            In addition to her teaching career, Dr. Berkovich is the Founder and
            Artistic Director of the Stella Unica International Young Artist
            Piano Competition, an international initiative dedicated to
            inspiring young musicians and promoting artistic excellence.
          </p>
          <p>
            Dr. Berkovich is a member of ASCAP and NACUSA and remains committed
            to helping students develop technical excellence, artistic
            confidence, and a lifelong appreciation for music.
          </p>
        </div>
      </div>
    </section>
  );
};
